import initialState from '../store/initial-state'
import {
  INDIVIDUAL_SELECT_ITEM,
  INDIVIDUAL_CLEAR,
} from '../constants/individual-action-types'

export default (state = initialState.individualSelect, action) => {
  switch (action.type) {
    
    case INDIVIDUAL_SELECT_ITEM:
      return {
        ...state,
        ...action.payload
      }
    case INDIVIDUAL_CLEAR:
      return {
        ...state,
        selectedFile: null,
      }
    default: return { ...state }
  }
}